// extracted by mini-css-extract-plugin
module.exports = {"container":"BadgesList_container__qKd5I","item":"BadgesList_item__4NHgp"};